module.exports = __webpack_public_path__ + "img/date-end_new.ff11092b.svg";